import request from '@/api/request'

// 登录验证码
export const sendLoginSms = (data) => {
  return request({
      url: '/rocket/sms/pLoginSms',
      method: 'get',
      params:{
        _token:localStorage.getItem('token'),
        ...data
      }
  })
}

// 验证码登录
export const loginSmsCode = (data) => {
  return request({
      url: '/rocket/userAuth/loginSmsCode',
      method: 'post',
      headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
      },
      params:{
        ...data
      }
  })
}


// 获取渠道信息
export const infoByChannel = (_channel) => {
    return request({
        url: '/zhijie/channel/infoByChannel',
        method: 'get',
        params:{
            _channel:_channel
        }
    })
  }



// WEBPACK FOOTER //
// ./src/api/Credit/user.js